import React, { FC } from 'react';
import { DecisionQpcFetcher } from './DecisionQpcFetcher';
import { DecisionQpcList } from './DecisionQpcList';

type Props = {
  articleId: string;
  source: string;
};

export const DecisionQpc: FC<Props> = ({ source, articleId }) => {
  return (
    <DecisionQpcFetcher articleId={articleId}>
      {decisions =>
        decisions.length > 0 ? (
          <DecisionQpcList source={source} decisions={decisions} />
        ) : null
      }
    </DecisionQpcFetcher>
  );
};
